"use strict";
exports.__esModule = true;
exports.AuthType = void 0;
exports.AuthType = {
    Lca: 'lca',
    WebAttestation: 'webAttestation',
    None: 'none'
};
//# sourceMappingURL=constants.js.map